module.exports = __webpack_public_path__ + "img/1.bc4783e3.png";